import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

interface ModalProps {
    isActive: boolean;
    onClose: () => void;
    disableBackdropClick?: boolean,
    headerRightComponent?: React.ReactNode
}

const inModal = <P extends object>(WrappedComponent: React.ComponentType<P>, title: string) => {
    const MilestoneOffcanvas: React.FC<P & ModalProps> = ({
        isActive,
        disableBackdropClick = false,
        onClose,
        headerRightComponent,
        ...props
    }) => {

        const onBackDropClick = () => {
            if (disableBackdropClick) return;
            onClose();
        }

        return (
            <Modal centered isOpen={isActive} toggle={onClose} direction='end' id="milestone-modal">
                <ModalHeader>
                    <h4>{title}</h4>
                </ModalHeader>
                <ModalBody>
                    {
                        isActive &&
                        <WrappedComponent {...(props as P)} onClose={onClose} />
                    }
                </ModalBody>
            </Modal>
        );
    };

    return MilestoneOffcanvas;
};

export default inModal;